import { useId } from 'react';

export const PROGRESS_MIN = 0;
export const PROGRESS_MAX = 100;
export const COMPLETED_TEXT = 'Completed';

export interface UseProgressRingResult {
  value: number;
  valueText: string;
  labelId: string;
}

export const useProgressRing = (value: number): UseProgressRingResult => {
  const labelId = useId();
  const clampedValue = Math.min(Math.max(value, PROGRESS_MIN), PROGRESS_MAX);
  const isComplete = clampedValue === PROGRESS_MAX;
  const valueText = isComplete ? COMPLETED_TEXT : `${clampedValue}% complete`;

  return { value: clampedValue, valueText, labelId };
};
